module.exports = __webpack_public_path__ + "static/media/study 201027.83156621.png";